@charset "UTF-8";

/* src/app/shared/order-tracking/order-tracking/order-tracking.component.scss */
:host .cw-order-price-summary {
  width: 350px;
}
:host .cw-order-price-summary #order_discount {
  width: 69px;
}
.cdk-table,
.mat-mdc-table {
  background: var(--color-default-light);
  width: 100%;
}
.cdk-header-row,
.mat-mdc-header-row {
  font: 700 1.3rem/44px Roboto, sans-serif;
  height: 44px;
  text-align: left;
  border-bottom-color: var(--color-accent);
}
.cdk-row,
.mat-mdc-row {
  border-bottom: 1px solid var(--color-primary-lighter);
  cursor: pointer;
  font: 400 1.3rem/44px Roboto, sans-serif;
  height: 44px;
  text-align: left;
  width: 100%;
}
.cdk-row:hover,
.mat-mdc-row:hover {
  background-color: var(--color-primary-light);
}
.cdk-row.selected,
.mat-mdc-row.selected {
  background-color: var(--color-primary-light);
}
.mat-mdc-header-cell,
.mat-mdc-cell {
  color: var(--color-default-dark);
  font-size: 13px;
  height: 44px;
  line-height: 1.8rem;
  max-height: 44px;
  max-width: 200px;
  min-width: 30px;
  overflow: hidden;
  padding-left: 10px;
  text-overflow: ellipsis;
  vertical-align: middle;
  white-space: nowrap;
}
:host .cw-set-width-cell {
  width: 90px;
  max-width: 90px;
}
:host .cw-limit-cell-width {
  max-width: calc(100% - 410px);
}
:host .cw-limit-cell-width.short {
  max-width: 40px;
}
:host ng-container[matColumnDef=deleteColumn] mat-cell {
  padding-right: 10px;
}
.mat-mdc-header-cell {
  border-bottom: none;
  font-weight: 700;
}
.mat-mdc-input-element:disabled {
  color: rgb(0, 0, 0);
}
:host ::ng-deep .mat-form-field-disabled .mat-form-field-underline {
  background-image: none !important;
  color: rgb(0, 0, 0);
}
:host table {
  float: left;
  width: 200px;
}
:host .input-field {
  text-align: right;
  width: 200px;
}
#order_discount_text ::ng-deep .cw-input-span {
  text-align: right;
}
:host ::ng-deep .cw-input-input {
  width: fit-content !important;
}
.clear {
  clear: both;
  height: 0;
  line-height: 0;
  font-size: 0;
}
:host .percent-input-warning ::ng-deep .cw-input-input {
  color: red;
}
:host ::ng-deep .mat-column-max_discount_text {
  color: red !important;
  font-size: 150% !important;
  font-weight: bold;
  min-width: 0 !important;
}
:host .header-margin {
  margin-top: 18px;
}
:host .extra-header-margin {
  margin-top: 36px;
}
:host .time-margin {
  margin-left: 12px;
}
:host .delivery-time-margin {
  margin-left: 42px;
}
:host .input-width {
  width: 200px;
}
#cw-order-tracking-documents .cw-toolbar-container {
  max-height: 35px;
  position: absolute;
  right: 0;
  top: -20px;
}
:host ::ng-deep .mat-mdc-cell {
  white-space: normal;
}
/*# sourceMappingURL=order-tracking.component.css.map */
